import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BusinessLoansFormFields } from "web_myplann/Portfolio/Forms/BusinessLoansForm/BusinessLoansFormFields";
import { useEditBusinessLoansForm } from "web_myplann/Portfolio/Forms/BusinessLoansForm/useEditBusinessLoansForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditBusinessLoansFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditBusinessLoansForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditBusinessLoansFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } =
		useEditBusinessLoansForm({
			portfolioId,
			portfolio,
			detailRoute,
		});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<BusinessLoansFormFields
				control={form.control}
				namePlaceholder={t(Resources.Portfolio.EditPortfolio.Placeholders.name)}
				contractNumberPlaceholder={t(
					Resources.Portfolio.EditPortfolio.Placeholders.contractNumber,
				)}
			/>
		</PortfolioFormShell>
	);
};
